import { OutboundLink } from "react-ga";
import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = theme => ({
  tab: {
    color: "#fff",
    display: "flex",
    height: "100%",
    alignItems: "center",
    textDecoration: "none",
    transition: "background-color .2s linear",
    "&:hover": {
      backgroundColor: theme.hoverColor
    },
    "@media (max-width: 823px)": {
      padding: 0
    }
  }
});

const Tab = ({ classes, targetLink, anchorText, className = "" }) => (
  <OutboundLink
    className={`${classes.tab} ${className}`}
    to={targetLink}
    eventLabel={anchorText}
  >
    {anchorText}
  </OutboundLink>
);

Tab.propTypes = {
  targetLink: PropTypes.string.isRequired,
  anchorText: PropTypes.string.isRequired,
  classes: PropTypes.object,
  className: PropTypes.string
};

export default injectSheet(styles)(Tab);



// WEBPACK FOOTER //
// ./src/components/TopBar/Tab.jsx